"use client";

import { Core } from "@faire/design-tokens";
import { getWindow } from "@faire/web/common/globals/getWindow";
import { Typography } from "@faire/web/slate/Typography";
import React, { useCallback } from "react";
import styled, { DefaultTheme } from "styled-components";

import { Link } from "../LinkAnchor";

import { IBreadcrumbOption } from "./Breadcrumbs";

interface IRenderOptionProps {
  optionData: IBreadcrumbOption;
  index: number;
  handleOnClick?: (optionData: IBreadcrumbOption) => void;
  isLastIndex?: boolean;
  theme: DefaultTheme;
}

const LinkText = styled.span`
  &:hover {
    border-bottom: 1px solid ${Core.border.default};
  }
`;

export const Option: React.FC<IRenderOptionProps> = ({
  optionData,
  index,
  handleOnClick,
  isLastIndex,
}) => {
  const onClick = useCallback(
    () => handleOnClick?.(optionData),
    [optionData, handleOnClick]
  );
  return optionData.path ? (
    <li
      key={optionData.path}
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
      onClick={onClick}
    >
      <Link
        to={optionData.path}
        key={optionData.path}
        itemScope
        itemProp="item"
        itemType="https://schema.org/WebPage"
        itemID={encodeURI(`${getWindow()?.location.origin}${optionData.path}`)}
      >
        <Typography>
          <LinkText itemProp="name">{optionData.label}</LinkText>
          {!isLastIndex ? "  /  " : ""}
        </Typography>
      </Link>
      <meta itemProp="position" content={`${index + 1}`} />
    </li>
  ) : (
    <li
      itemProp="itemListElement"
      itemScope
      itemType="https://schema.org/ListItem"
    >
      <Typography color={Core.text.subdued} itemProp="name">
        {optionData.label}
      </Typography>
      <meta itemProp="position" content={`${index + 1}`} />
    </li>
  );
};
